import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Inventario',
    path: '/inventario/entradas-salidas',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const EntradasSalidasPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Movimientos</PageTitle>
      <View />
    </>
  );
};

export { EntradasSalidasPage };
